module.exports = __webpack_public_path__ + "static/media/explosion.113c2fe9.png";